/**
 * Smilodox Secret Sale — tiny global recovery bootstrap.
 * Dormant by default: no cart fetch, no checkout listeners, no full probe download.
 * Loads the full probe only when a same-tab or stale persistent recovery marker exists.
 * If a persist marker is still fresh (active probe elsewhere), schedules a retry once stale.
 */
(function () {
  "use strict";

  if (window.__smilodoxSecretSaleRecoveryBooted) return;
  window.__smilodoxSecretSaleRecoveryBooted = true;

  const STORAGE_SESSION = "smilodox:secret-sale:probe-pending";
  const STORAGE_PERSIST = "smilodox:secret-sale:probe-pending-persist";
  const STORAGE_TAB_OWNER = "smilodox:secret-sale:tab-owner";
  const STALE_MS = 15000;

  let staleTimer = null;

  function readSessionMarker() {
    try {
      return sessionStorage.getItem(STORAGE_SESSION) || "";
    } catch (e) {
      return "";
    }
  }

  function readPersist() {
    try {
      const raw = localStorage.getItem(STORAGE_PERSIST);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function getTabOwnerId() {
    try {
      let id = sessionStorage.getItem(STORAGE_TAB_OWNER);
      if (id) return id;
      id =
        (window.crypto && typeof window.crypto.randomUUID === "function" && window.crypto.randomUUID()) ||
        "t-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem(STORAGE_TAB_OWNER, id);
      return id;
    } catch (e) {
      return "t-anon";
    }
  }

  function shouldAttemptRecovery() {
    if (readSessionMarker()) return true;
    const persist = readPersist();
    if (!persist || !persist.token) return false;
    if (String(persist.owner || "") === String(getTabOwnerId())) return true;
    const at = Number(persist.at || 0);
    if (!at) return true;
    return Date.now() - at >= STALE_MS;
  }

  function probeSrc() {
    try {
      const cfg = window.SmilodoxSecretSaleRecoveryConfig;
      if (cfg && cfg.probeSrc) return String(cfg.probeSrc);
    } catch (e) {}
    return "";
  }

  function whenProbeReady(cb) {
    if (
      window.SmilodoxSecretSaleProbe &&
      typeof window.SmilodoxSecretSaleProbe.recoverStrandedProbeLines === "function"
    ) {
      cb(window.SmilodoxSecretSaleProbe);
      return;
    }
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (
        window.SmilodoxSecretSaleProbe &&
        typeof window.SmilodoxSecretSaleProbe.recoverStrandedProbeLines === "function"
      ) {
        window.clearInterval(timer);
        cb(window.SmilodoxSecretSaleProbe);
        return;
      }
      if (tries > 80) window.clearInterval(timer);
    }, 50);
  }

  function loadFullProbeThenRecover() {
    whenProbeReady(function (probe) {
      try {
        probe.recoverStrandedProbeLines();
      } catch (e) {}
    });

    if (window.SmilodoxSecretSaleProbe || window.__smilodoxSecretSaleProbeBooted) return;
    if (window.__smilodoxSecretSaleProbeLoading) return;

    const src = probeSrc();
    if (!src) return;

    window.__smilodoxSecretSaleProbeLoading = true;
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.dataset.smilodoxSecretSaleRecovery = "1";
    script.onload = function () {
      window.__smilodoxSecretSaleProbeLoading = false;
    };
    script.onerror = function () {
      window.__smilodoxSecretSaleProbeLoading = false;
    };
    (document.head || document.documentElement).appendChild(script);
  }

  function clearStaleTimer() {
    if (staleTimer != null) {
      window.clearTimeout(staleTimer);
      staleTimer = null;
    }
  }

  function scheduleStaleRetry() {
    clearStaleTimer();

    if (shouldAttemptRecovery()) {
      loadFullProbeThenRecover();
      return;
    }

    const persist = readPersist();
    if (!persist || !persist.token) return;
    if (String(persist.owner || "") === String(getTabOwnerId())) return;

    const at = Number(persist.at || 0);
    if (!at) {
      loadFullProbeThenRecover();
      return;
    }

    const wait = STALE_MS - (Date.now() - at);
    if (wait <= 0) {
      loadFullProbeThenRecover();
      return;
    }

    // Re-check when the active tab’s heartbeat should have gone silent.
    staleTimer = window.setTimeout(function () {
      staleTimer = null;
      scheduleStaleRetry();
    }, Math.min(wait + 250, STALE_MS + 250));
  }

  try {
    window.addEventListener("storage", function (event) {
      if (!event || event.key !== STORAGE_PERSIST) return;
      scheduleStaleRetry();
    });
  } catch (e) {}

  if (shouldAttemptRecovery()) {
    loadFullProbeThenRecover();
  } else if (readPersist()) {
    scheduleStaleRetry();
  }
})();
